import { useDroppable } from '@dnd-kit/core';
import type { Card as CardType, Column as ColumnType } from '../data/types';
import { Card } from './Card';
import styles from './Column.module.css';

interface ColumnProps {
  column: ColumnType;
  cards: CardType[];
  /** When true, render a single hero card on the deck (the top of the stack). */
  isDeck?: boolean;
  onPickColumnForTop?: () => void;
}

export function Column({ column, cards, isDeck = false, onPickColumnForTop }: ColumnProps) {
  const { setNodeRef, isOver } = useDroppable({ id: column.id });

  return (
    <section
      ref={setNodeRef}
      className={`${styles.column} ${isOver ? styles.over : ''}`}
      style={{ borderTopColor: column.accent }}
      aria-label={`${column.label} column, ${cards.length} cards`}
    >
      <header className={styles.head}>
        <h2 className={styles.label}>{column.label}</h2>
        <span className={styles.count}>{cards.length}</span>
      </header>
      <p className={styles.hint}>{column.hint}</p>

      <div className={styles.cards}>
        {isDeck ? (
          cards.length === 0 ? (
            <p className={styles.empty}>the deck is empty. you have sorted every card.</p>
          ) : (
            // Show top card prominently, the rest as a thin stack
            <>
              <Card key={cards[0]!.id} card={cards[0]!} onPickColumn={onPickColumnForTop} />
              {cards.length > 1 && (
                <p className={styles.stackHint}>
                  {cards.length - 1} more in the deck
                </p>
              )}
            </>
          )
        ) : cards.length === 0 ? (
          <p className={styles.empty}>drop cards here</p>
        ) : (
          cards.map((card) => <Card key={card.id} card={card} compact />)
        )}
      </div>
    </section>
  );
}
